module.exports = __webpack_public_path__ + "static/media/armadillo-booking-7.239d4895.png";